import React from "react";
import { Form, Button, InputProps, FormProps, ButtonProps } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { useCompanyForm } from "../../data/companies/useCompanyForm";
import { ICompanyFormData } from "../../models/ICompany";

interface CompanyFormProps extends Pick<FormProps, "loading"> {
    onSubmit: (values: ICompanyFormData) => void;
    onCancel: () => void;
};

const CompanyForm: React.FC<CompanyFormProps> = ({ onSubmit, onCancel, children }) => {
    const { t } = useTranslation();

    const texts = {
        save: t("Tallenna"),
        name: t("Nimi"),
        cancel: t("Peruuta")
    };

    const { formData, update, validate, errors } = useCompanyForm();


    const handleSubmit: ButtonProps["onClick"] = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const hasErrors = validate(formData);
        if (hasErrors) return;

        onSubmit(formData);
    };


    const nameChange: InputProps["onChange"] = (_1, { value: name }) => update({ name });

    return (
        <Form >

            <Form.Input
                error={errors.name}
                label={texts.name}
                value={formData.name}
                onChange={nameChange}
            />

            <Button
                type="button"
                primary
                onClick={handleSubmit}
                content={texts.save}
            />
            <Button
                type="button"
                onClick={onCancel}
                content={texts.cancel}
            />
        </Form>
    );
};


export default CompanyForm;
